import React from 'react';
import JobCompanyLogo from '../../../JobBoard/JobCompanyLogo';
import { formatDateToShortDotV2, Checkbox } from '@repo/common';

const ApplicationRow = ({
  data,
  checked,
  onCheckboxChange,
  selectedTab,
  onClick,
  $isMobile,
}) => {
  const isSubmitted = selectedTab === 'submitted';
  const isSaved = selectedTab === 'saved';
  const isApplied = selectedTab === 'applied';

  return (
    <div
      className='flex py-2 items-center w-full typo-b14 text-text-secondary cursor-pointer'
      onClick={onClick}
    >
      <div className='pr-2 tabletH:px-2' onClick={(e) => e.stopPropagation()}>
        <Checkbox checked={checked} onChange={onCheckboxChange} />
      </div>

      <div className='pl-2 pr-3 tabletH:px-2'>
        <JobCompanyLogo
          src={data.companyLogoUrl}
          sizeClassName='size-[42px] tabletH:size-6'
          padding='p-1.5 tabletH:p-0.5'
        />
      </div>

      <div className='flex flex-col tabletH:flex-row w-full min-w-0 pr-2 tabletH:p-0 gap-1 tabletH:gap-0'>
        {!$isMobile && (
          <div className='w-full max-w-[140px] px-2'>{data.companyName}</div>
        )}
        {isApplied && $isMobile && (
          <div className='flex flex-col min-w-0 text-text-secondary'>
            <span className='w-full flex justify-start items-center typo-b14Strong'>
              {data.status === 'SUBMITTED' && 'Submitted'}
            </span>

            <div className='flex items-center gap-1 min-w-0'>
              <span className='shrink-0 typo-b12Strong'>
                {data.companyName}
              </span>
              <div className='shrink-0 w-[3px] h-[3px] rounded-full bg-grayscale-gray05' />
              <span className='min-w-0 truncate typo-b12'>{data.title}</span>
            </div>
          </div>
        )}

        {!isApplied && (
          <div
            className={`flex w-full ${
              isSubmitted
                ? 'max-w-[360px]'
                : isSaved
                  ? 'max-w-[620px]'
                  : 'max-w-[490px]'
            } tabletH:px-2 justify-start tabletH:justify-center items-center`}
          >
            <span className='overflow-hidden whitespace-nowrap text-ellipsis typo-b14Strong tabletH:typo-b14'>
              {data.title}
            </span>
          </div>
        )}

        {$isMobile && !isApplied && (
          <div className='w-full text-text-secondary'>
            <div className='flex items-center gap-1 w-full tabletH:max-w-[140px] tabletH:px-2 typo-b12Strong'>
              <span>{data.companyName}</span>
              <div className='shrink-0 w-[3px] h-[3px] rounded-full bg-grayscale-gray05 ' />
              <span className='typo-b12'>{data.location}</span>
              <div className='shrink-0 w-[3px] h-[3px] rounded-full bg-grayscale-gray05' />
              <span className='typo-b12'>{data.employmentType}</span>
            </div>
          </div>
        )}

        {!isSaved && !isApplied && (
          <div className='w-full max-w-[130px] px-2 flex justify-center items-center'>
            {formatDateToShortDotV2(data.createdAt)}
          </div>
        )}

        {(isSubmitted || isApplied) && !$isMobile && (
          <div className='w-full max-w-[130px] px-2 flex justify-center items-center'>
            {data.status === 'SUBMITTED' && 'Submitted'}
          </div>
        )}
      </div>
    </div>
  );
};

export default ApplicationRow;
